export const SET_GOOGLE_ANALYTIC_TRACKING = 'SET_GOOGLE_ANALYTIC_TRACKING';

export default {
  SET_GOOGLE_ANALYTIC_TRACKING,
};
